import colors from 'vuetify/util/colors';
import { AppColors } from '@/themes/theme';

export const polandColors: Partial<AppColors> = {
  systemPrimary: '#E40613',
  systemSecondary: '#073855',
  buttonPrimary: '#073855',
  primary: '#0C7396',
  buttonWarning: colors.red.darken1,
  buttonConfirm: colors.green.darken2,
  buttonDefault: colors.grey.darken1,
  rdpbackground: '#d4d4d4',
  leftpanelhover: '#c46064',
};
